import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { StandbyDashboardComponent } from './dispatch/standby-dashboard/standby-dashboard.component';
import { DayDetailsComponent } from './dispatch/standby-dashboard/day-details/day-details.component';
import { DayItemDetailsComponent } from './dispatch/standby-dashboard/day-item-details/day-item-details.component';
import { HomePageComponent } from './shell/home-page/home-page.component';
import { ReadonlyComponent } from './reservations/readonly/readonly.component';
import { ReservationsComponent } from './reservations/reservations.component';
import { CallBoardDashboardComponent } from './contact-center/call-board-dashboard/call-board-dashboard.component';
import { AgentBoardDashboardComponent } from './contact-center/agent-board-dashboard/agent-board-dashboard.component';

import { AuthComponent } from './share/components/auth/auth.component';
import { AlertAnalyzesComponent } from './contact-center/avaya-dashboards/alert-analyzes/alert-analyzes.component';
import { AlertDetailComponent } from './contact-center/avaya-dashboards/alert-analyzes/alert-detail/alert-detail.component';
import { FeedbackEntryComponent } from './share/feedback/feedback-entry/feedback-entry.component';
import { ReportsDashboardComponent } from './reports/reports-dashboard/reports-dashboard.component';
import { ExpWinAccountabilityComponent } from './reservations/exp-win-accountability/exp-win-accountability.component';
import { ExpWinAccountabilityDetailComponent } from './reservations/exp-win-accountability/exp-win-accountability-detail/exp-win-accountability-detail.component';
import { AuthGuard } from './share/guards/auth.guard';
import { NetjetsCrossroadsComponent } from './reservations/netjets-crossroads/netjets-crossroads.component';
import { RateIssueComponent } from './reservations/rates/rate-issue/rate-issue.component';
import { LiveGpsComponent } from './dispatch/live-gps/live-gps.component';
import { AffPortExceptionComponent } from './affiliates/affiliate-portal/aff-port-exception/aff-port-exception.component';
import { AppBuddyComponent } from './app-buddy/app-buddy.component';
import { TourManagementComponent } from './reservations/tour-management/tour-management.component';

import { ViewPayReportComponent } from './affiliates/affiliate-portal/components/view-pay-report/view-pay-report.component';
import { TableDataComponent } from './reports/table-data/table-data.component';
import { WebApplicationsComponent } from './reservations/web-applications/web-applications.component';
import { AffRateIssueComponent } from './affiliates/aff-rate-issue/aff-rate-issue.component';
import { RatesDashboardComponent } from './reservations/rates/rates-dashboard/rates-dashboard.component';
import { DiscountCalculatorComponent } from './reservations/rates/discount-calculator/discount-calculator.component';
import { TourManagementDetailComponent } from './reservations/tour-management/tour-management-detail/tour-management-detail.component';
import { PayrollComponent } from './chauffeurs/payroll/payroll.component';
import { VehicleRequestPageComponent } from './reservations/pages/vehicle-request-page/vehicle-request-page.component';
import { CreditCardIdentityPageComponent } from './reservations/pages/credit-card-identity-page/credit-card-identity-page.component';
import { UserActivityMonitorComponent } from './reservations/user-activity-monitor/user-activity-monitor.component';
import { TrendDashboardComponent } from './reports/trend-dashboard/trend-dashboard.component';
import { TrendReportsComponent } from './reports/trend-reports/trend-reports.component';
import { WweManifestPageComponent } from './reservations/pages/wwe-manifest-page/wwe-manifest-page.component';
import { ChauffeurEmailsComponent } from './chauffeurs/chauffeur-emails/chauffeur-emails.component';
import { LiveTripsPageComponent } from './external/pages/live-trips/live-trips-page.component';
import { environment } from 'src/environments/environment';
import { SalesmanDashboardComponent } from './reports/salesman-dashboard/salesman-dashboard.component';
import { SalesmanReportsComponent } from './reports/salesman-reports/salesman-reports.component';
import { FrontAnalysisPageComponent } from './reservations/pages/front-analysis-page/front-analysis-page.component';
import { VendorPayoutComponent } from './accounting/vendor-payout/vendor-payout.component';
import { ChauffeurHrComponent } from './chauffeurs/chauffeur-hr/chauffeur-hr.component';
import { AffiliatePayoutComponent } from './costing/affiliate-payout/affiliate-payout.component';
import { ChauffeurPortalComponent } from './chauffeurs/chauffeur-portal/chauffeur-portal.component';
import { TimesheetsComponent } from './chauffeurs/payroll/timesheets/timesheets.component';
import { BreakEditComponent } from './chauffeurs/payroll/break-edit/break-edit.component';

/**
 *
 */
class RoutesContext {
  /**
   *  routes for the customer deployment type
   * @returns
   */
  private static customer(): Routes {
    const ret: Routes = [
      { path: '', component: HomePageComponent },
      { path: 'home', component: HomePageComponent },
      { path: 'reservations/manifest', component: LiveTripsPageComponent, canActivate: [AuthGuard] },

      // auth
      { path: 'login', component: AuthComponent }

    ];
    return ret;
  }

  /**
   *  routes for the external deployment type
   * @returns
   */
  private static external(): Routes {
    const ret: Routes = [
      { path: '', component: HomePageComponent },
      { path: 'home', component: HomePageComponent },

      // auth
      { path: 'login', component: AuthComponent }

    ];
    return ret;
  }

  /**
   * routes for the chauffeur deployment type
   * @returns
   */
  private static chauffeur(): Routes {
    const ret: Routes = [
      { path: '', component: HomePageComponent },
      { path: 'home', component: HomePageComponent },
      { path: 'payroll/timesheets/:sheetId', component: TimesheetsComponent },
      { path: 'payroll/breaks/:breakId', component: BreakEditComponent },

      // auth
      { path: 'login', component: AuthComponent }

    ];
    return ret;
  }



  /**
   *  routes for the internal deployment type
   * @returns
   */
  private static internal(): Routes {
    const ret: Routes = [
      { path: '', component: HomePageComponent },
      { path: 'home', component: HomePageComponent },

      { path: 'feedback', component: FeedbackEntryComponent, canActivate: [AuthGuard]  },

      { path: 'reports', component: ReportsDashboardComponent, canActivate: [AuthGuard] },
      { path: 'reports/:code', component: TableDataComponent, canActivate: [AuthGuard] },
      { path: 'trend-reports-dashboard', component: TrendDashboardComponent, canActivate: [AuthGuard] },
      { path: 'trend-report/:type/:line', component: TrendReportsComponent, canActivate: [AuthGuard] },
      { path: 'salesman-reports-dashboard', component: SalesmanDashboardComponent, canActivate: [AuthGuard] },
      { path: 'salesman-report/:type/:line', component: SalesmanReportsComponent, canActivate: [AuthGuard] },

      // dispatch
      { path: 'live-gps', component: LiveGpsComponent, canActivate: [AuthGuard] },
      // { path: 'dispatch/standbys', component: StandbyDashboardComponent, canActivate: [AuthGuard] },
      // { path: 'dispatch/standbys/day/:day', component: DayDetailsComponent, canActivate: [AuthGuard] },
      // { path: 'dispatch/standbys/day/:day/:group/:key', component: DayItemDetailsComponent, canActivate: [AuthGuard] },

      // app buddy
      { path: 'santaCruz/app-buddy', component: AppBuddyComponent },

      // accounting
      { path: 'accounting/vendor-payout', component: VendorPayoutComponent, canActivate: [AuthGuard] },

      // costing
      { path: 'costing/affiliate-payout', component: AffiliatePayoutComponent, canActivate: [AuthGuard] },

      // affiliates
      { path: 'affiliate-portal/view-pay-report', component: ViewPayReportComponent },
      { path: 'affport-exceptions', component: AffPortExceptionComponent, canActivate: [AuthGuard] },
      { path: 'aff-rate-issue', component: AffRateIssueComponent, canActivate: [AuthGuard] },

      // chauffeurs
      { path: 'chauffeurs/emails', component: ChauffeurEmailsComponent, canActivate: [AuthGuard] },
      { path: 'chauffeurs/payroll', component: PayrollComponent, canActivate: [AuthGuard] },
      { path: 'chauffeurs/hr', component: ChauffeurHrComponent, canActivate: [AuthGuard] },
      { path: 'chauffeurs/chauffeur-portal/:driverCode', component: ChauffeurPortalComponent, canActivate: [AuthGuard] },

      // reservations
      { path: 'reservations/rates', component: RatesDashboardComponent, canActivate: [AuthGuard] },
      { path: 'santaCruz/rates/discount-calculator', component: DiscountCalculatorComponent, canActivate: [AuthGuard] },
      { path: 'exp-win-accountability', component: ExpWinAccountabilityComponent, canActivate: [AuthGuard] },
      { path: 'reservations/exp-win-accountability-detail/:resId/:auditLogId', component: ExpWinAccountabilityDetailComponent, canActivate: [AuthGuard] },
      { path: 'netjets-crossroads', component: NetjetsCrossroadsComponent, canActivate: [AuthGuard] },
      { path: 'rate-issue', component: RateIssueComponent, canActivate: [AuthGuard] },
      { path: 'web-applications', component: WebApplicationsComponent, canActivate: [AuthGuard] },
      { path: 'user-activity-monitor', component: UserActivityMonitorComponent, canActivate: [AuthGuard] },
      { path: 'reservations/tour-management', component: TourManagementComponent, canActivate: [AuthGuard] },
      { path: 'reservations/tour-management-detail/:tourId', component: TourManagementDetailComponent, canActivate: [AuthGuard] },

      { path: 'reservations/credit-card-identity', component: CreditCardIdentityPageComponent, canActivate: [AuthGuard] },
      { path: 'reservations/request-vehicle', component: VehicleRequestPageComponent, canActivate: [AuthGuard] },
      { path: 'reservations/customer-manifest', component: WweManifestPageComponent, canActivate: [AuthGuard] },
      { path: 'reservations/front-analysis', component: FrontAnalysisPageComponent, canActivate: [AuthGuard] },

      // call center
      { path: 'dashboards/call-board/:view/:boardLocation', component: CallBoardDashboardComponent, canActivate: [AuthGuard] },
      { path: 'dashboards/agent-board', component: AgentBoardDashboardComponent, canActivate: [AuthGuard] },
      { path: 'dashboards/avaya-dashboards/alert-analyzes/alert-analyzes', redirectTo: 'dashboards/alerts' },
      { path: 'dashboards/alerts', component: AlertAnalyzesComponent, canActivate: [AuthGuard] },
      { path: 'dashboards/avaya-dashboards/alert-analyzes/alert-detail/alert-detail', redirectTo: 'dashboards/alert-detail' },
      { path: 'dashboards/alert-detail/:id', component: AlertDetailComponent, canActivate: [AuthGuard] },

      // one time use stuff
      { path: 'ot/1001/:wfis/:accessToken', component: VehicleRequestPageComponent } /* VehReq */,
      { path: 'ot/1002/:wfis/:accessToken', component: CreditCardIdentityPageComponent } /* ResCcIdReq */,

      // auth
      { path: 'login', component: AuthComponent }
    ];
    return ret;
  }

  /**
   *
   * @returns
   */
  public static routes(): Routes {
    const ret = environment.deploymentType == 'internal' ? RoutesContext.internal()
      : environment.deploymentType == 'external' ? RoutesContext.external()
      : environment.deploymentType == 'customer' ? RoutesContext.customer()
      : environment.deploymentType == 'chauffeur' ? RoutesContext.chauffeur()
      : [];
    return ret;
  }
}

/**
 *
 */
 @NgModule({
  imports: [RouterModule.forRoot(RoutesContext.routes(), { useHash: true, relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
